/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { PlateWindowBlock } from "src/classes/block/block-types";
import {
  EmbeddedPlateBlockContent,
  PageBlockMaxWidth,
  PageBlockWrapper,
} from "src/components/Block/BlockTypes/EmbeddedPlate/lib/styles";
import { MessageBlock } from "src/components/Block/Placeholders/MessageBlock";
import { PageThumbnail } from "src/components/Shared/PageThumbnail";

interface Props {
  block: PlateWindowBlock;
}

export function EmbeddedPlate({ block }: Props) {
  return (
    <EmbeddedPlateBlockContent>
      {!block.embeddedPlate ? (
        <MessageBlock>Plate deleted or made private.</MessageBlock>
      ) : (
        <PageBlockWrapper>
          <PageBlockMaxWidth>
            <PageThumbnail plate={block.embeddedPlate} disableContextMenu />
          </PageBlockMaxWidth>
        </PageBlockWrapper>
      )}
    </EmbeddedPlateBlockContent>
  );
}
